import { Directive, OnDestroy, OnInit, Self, TemplateRef } from '@angular/core';

import { GlobalLayoutStore } from '@services/store/global-layout.store';

@Directive({
  selector: '[appBreadcrumbsWidget]'
})
export class BreadcrumbsWidgetDirective implements OnInit, OnDestroy {
  constructor(@Self() private templateRef: TemplateRef<any>, private globalLayoutStore: GlobalLayoutStore) { }

  ngOnInit(): void {
    this.globalLayoutStore.setBreadcrumbsWidget(this.templateRef);
  }

  ngOnDestroy(): void {
    this.globalLayoutStore.removeBreadcrumbsWidget();
  }
}
